__turbopack_context__.v({
  "learn-content-carousel-card": "L7d3RG_learn-content-carousel-card",
  "learn-content-carousel-card__action": "L7d3RG_learn-content-carousel-card__action",
  "learn-content-carousel-card__authors": "L7d3RG_learn-content-carousel-card__authors",
  "learn-content-carousel-card__bookmark-icon": "L7d3RG_learn-content-carousel-card__bookmark-icon",
  "learn-content-carousel-card__content": "L7d3RG_learn-content-carousel-card__content",
  "learn-content-carousel-card__description": "L7d3RG_learn-content-carousel-card__description",
  "learn-content-carousel-card__first-author": "L7d3RG_learn-content-carousel-card__first-author",
  "learn-content-carousel-card__info": "L7d3RG_learn-content-carousel-card__info",
  "learn-content-carousel-card__lock-icon": "L7d3RG_learn-content-carousel-card__lock-icon",
  "learn-content-carousel-card__other-authors": "L7d3RG_learn-content-carousel-card__other-authors",
  "learn-content-carousel-card__read-time": "L7d3RG_learn-content-carousel-card__read-time",
  "learn-content-carousel-card__read-time--with-separator": "L7d3RG_learn-content-carousel-card__read-time--with-separator",
  "learn-content-carousel-card__title": "L7d3RG_learn-content-carousel-card__title",
  "learn-content-carousel-card__type-badge-container": "L7d3RG_learn-content-carousel-card__type-badge-container",
  "learn-content-carousel-card__type-badge-text": "L7d3RG_learn-content-carousel-card__type-badge-text",
  "learn-content-carousel-card__type-icon": "L7d3RG_learn-content-carousel-card__type-icon",
  "random-item-indicator": "L7d3RG_random-item-indicator",
});
